module.exports = __webpack_public_path__ + "img/messagetosend-logo.c3a3e6e8.svg";